import { render, staticRenderFns } from "./SwappingSquaresSpinner.vue?vue&type=template&id=b85b25de&scoped=true&"
import script from "./SwappingSquaresSpinner.vue?vue&type=script&lang=js&"
export * from "./SwappingSquaresSpinner.vue?vue&type=script&lang=js&"
import style0 from "./SwappingSquaresSpinner.vue?vue&type=style&index=0&id=b85b25de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85b25de",
  null
  
)

export default component.exports